import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import Loader from "../../ui/Loader";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { commonDeleteApi } from "../../../redux/reducers/deleteApiSlice";
import { delete_hygiene_task_freq } from "../../../data/ApiEndpoints";

const TaskFrequency = ({
  userInfoData,
  setModValues,
  isPage,
  setIsPage,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { loading: delApiLoading } = useSelector((state) => state.delApi);
  const {
    hygineTaskFrequency,
    hygineTaskFrequencyLoading,
    hygineTaskFrequencyError,
  } = useSelector((state) => state.hygiene);

  const iniDatas = {
    allDatas: [],
    pagination: [],
  };
  const [hygineData, setHygineData] = useState(iniDatas);

  const handleDelete = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: delete_hygiene_task_freq,
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            callFunction();
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete");
        }
      };

      showConfirmAlert(handleConfirm, `Are you sure, you want to delete!`);
    } else {
      toast.error("UID required!");
    }
  };

  useEffect(() => {
    if (
      !hygineTaskFrequencyLoading &&
      !hygineTaskFrequencyError &&
      hygineTaskFrequency?.status &&
      hygineTaskFrequency?.data?.length > 0
    ) {
      setHygineData((prevs) => ({
        ...prevs,
        allDatas: hygineTaskFrequency.data,
        pagination: hygineTaskFrequency?.pagination || [],
      }));
    } else {
      setHygineData(iniDatas);
    }
  }, []);

  const tbColumns = [
    {
      dataField: "name",
      text: "status name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.name?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="hygiene-action-btn-container minWidth100">
          <button
            className="actionBtn icon edit"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                rowData: row,
                cardName: "edit",
              }))
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M3.81504 23.1597H18.0224C18.9029 23.1572 19.7465 22.8054 20.368 22.1816C20.9895 21.5578 21.3382 20.7129 21.3374 19.8323V12.6936C21.3374 12.4424 21.2376 12.2015 21.06 12.0239C20.8824 11.8462 20.6415 11.7465 20.3902 11.7465C20.139 11.7465 19.8981 11.8462 19.7205 12.0239C19.5429 12.2015 19.4431 12.4424 19.4431 12.6936V19.8323C19.4444 20.2106 19.2955 20.574 19.0291 20.8427C18.7627 21.1113 18.4007 21.2634 18.0224 21.2654H3.81504C3.43672 21.2634 3.07465 21.1113 2.8083 20.8427C2.54194 20.574 2.39305 20.2106 2.39431 19.8323V5.64962C2.39305 5.2713 2.54194 4.90793 2.8083 4.63926C3.07465 4.3706 3.43672 4.21858 3.81504 4.21657H10.9187C11.1699 4.21657 11.4108 4.11679 11.5884 3.93916C11.7661 3.76153 11.8659 3.52062 11.8659 3.26942C11.8659 3.01822 11.7661 2.77731 11.5884 2.59968C11.4108 2.42205 11.1699 2.32227 10.9187 2.32227H3.81504C2.93448 2.32477 2.09088 2.67653 1.46937 3.30034C0.847872 3.92415 0.499245 4.76905 0.500001 5.64962V19.8323C0.499245 20.7129 0.847872 21.5578 1.46937 22.1816C2.09088 22.8054 2.93448 23.1572 3.81504 23.1597Z"
                fill="#0B0B0C"
              />
              <path
                d="M9.4487 10.4124L8.7014 13.8354C8.66757 13.9907 8.67335 14.152 8.71821 14.3044C8.76306 14.4569 8.84555 14.5956 8.95807 14.7078C9.07215 14.8172 9.21091 14.8974 9.3626 14.9418C9.51428 14.9861 9.67443 14.9933 9.82946 14.9626L13.2449 14.2134C13.4222 14.1744 13.5847 14.0853 13.7128 13.9567L22.3452 5.32432C22.6091 5.06046 22.8184 4.74719 22.9612 4.40242C23.1041 4.05765 23.1776 3.68811 23.1776 3.31493C23.1776 2.94174 23.1041 2.57221 22.9612 2.22743C22.8184 1.88266 22.6091 1.5694 22.3452 1.30554C21.8041 0.788521 21.0846 0.5 20.3362 0.5C19.5879 0.5 18.8684 0.788521 18.3273 1.30554L9.70822 9.94643C9.57886 10.0737 9.48878 10.2354 9.4487 10.4124ZM19.6666 2.64576C19.8468 2.47313 20.0867 2.37676 20.3362 2.37676C20.5858 2.37676 20.8257 2.47313 21.0059 2.64576C21.1811 2.82442 21.2793 3.06468 21.2793 3.31493C21.2793 3.56517 21.1811 3.80543 21.0059 3.98409L20.3362 4.65373L18.997 3.31445L19.6666 2.64576ZM11.2369 11.0887L17.653 4.65657L18.979 5.98922L12.5601 12.4232L10.86 12.7964L11.2369 11.0887Z"
                fill="#0B0B0C"
              />
            </svg>
          </button>

          <button
            className="actionBtn icon delete"
            onClick={() => {
              const uidFilter = {
                uid: row?.uid || "",
              };
              handleDelete(uidFilter);
            }}
          >
            {delApiLoading ? (
              <Loader />
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
              >
                <path
                  d="M8.16797 24.5C7.5263 24.5 6.977 24.2715 6.52005 23.8146C6.06311 23.3576 5.83464 22.8083 5.83464 22.1667V7H4.66797V4.66667H10.5013V3.5H17.5013V4.66667H23.3346V7H22.168V22.1667C22.168 22.8083 21.9395 23.3576 21.4826 23.8146C21.0256 24.2715 20.4763 24.5 19.8346 24.5H8.16797ZM19.8346 7H8.16797V22.1667H19.8346V7ZM10.5013 19.8333H12.8346V9.33333H10.5013V19.8333ZM15.168 19.8333H17.5013V9.33333H15.168V19.8333Z"
                  fill="#D7263D"
                />
              </svg>
            )}
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="hygiene-tb-container mt30">
      {hygineTaskFrequencyLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <PaymentLinkTable
          tableData={hygineData.allDatas}
          tableColumns={tbColumns}
          tablePagination={hygineData.pagination}
          isPage={isPage}
          setIsPage={(value) => setIsPage(value)}
        />
      )}
    </div>
  );
};

export default TaskFrequency;
